'use client';

import { createContext, useContext, useEffect, useState } from 'react';

// Types
import { ProductBackgroundColour } from '@/types/styling/product';
import { ProductVariantState } from '@/types/products/productVariants';
import { Context, ProviderProps } from '@/types/contexts/productDetailsContext';

// Constants
import { ProductDetailsClassName } from '@/constants/configuration';

// Contexts
import { useSiteContext } from '@/context/SiteProvider';

export const ProductDetailsContext = createContext<Context>({
  selectedProduct: undefined,
  setSelectedProduct: () => [],

  colourScheme: undefined,
  setColourScheme: () => [],
});

export const ProductDetailsProvider = ({ children }: ProviderProps) => {
  const { setBodyClasses } = useSiteContext();

  const [selectedProduct, setSelectedProduct] = useState<
    ProductVariantState | undefined
  >(undefined);

  const [colourScheme, setColourScheme] = useState<
    ProductBackgroundColour | undefined
  >(undefined);

  useEffect(() => {
    const classes = [ProductDetailsClassName];

    if (colourScheme) {
      classes.push(colourScheme);
    }

    setBodyClasses(classes);
  }, [colourScheme]);

  return (
    <ProductDetailsContext.Provider
      value={{
        selectedProduct: selectedProduct,
        setSelectedProduct: setSelectedProduct,

        colourScheme: colourScheme,
        setColourScheme: setColourScheme,
      }}
    >
      {children}
    </ProductDetailsContext.Provider>
  );
};

export const useProductDetailsContext = () =>
  useContext<Context>(ProductDetailsContext);
